import { render, staticRenderFns } from "./PaymentMethodBalanceList.vue?vue&type=template&id=b487c522"
import script from "@/controllers/payment_method_balance/payment-method-balance-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/payment_method_balance/payment-method-balance-list.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethodBalanceList.vue?vue&type=style&index=0&id=b487c522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports